import { AgentsZapierFacade, AppDetails, ZapierFacadeError } from ".";
import { implementationNeedsAuth } from "./authentications";
import { getCached } from "./cache";

async function getImplementationResults(
  facade: AgentsZapierFacade,
  params: {
    selectedApi: string;
  },
) {
  return getCached(
    facade.cache,
    "implementations",
    params.selectedApi,
    async () => {
      const { data, error, response } = await facade.api.GET(
        "/api/v4/implementations/",
        {
          params: {
            query: {
              global: true,
              selected_apis: params.selectedApi,
            },
          },
        },
      );

      if (error) {
        throw new ZapierFacadeError(
          "/api/v4/implementations/",
          "GET",
          { selected_api: params.selectedApi },
          response,
          error,
        );
      }

      return data?.results ?? [];
    },
  );
}

export async function getImplementation(
  facade: AgentsZapierFacade,
  params: {
    selectedApi: string;
  },
) {
  let results = await getImplementationResults(facade, params);

  // if we get no results, it can mean that we need to pass in a version
  // since AI Actions are all versionless, we just use `@latest` here...
  if (results.length === 0 && !params.selectedApi.includes("@latest")) {
    results = await getImplementationResults(facade, {
      selectedApi: `${params.selectedApi}@latest`,
    });
  }

  if (results.length === 0) {
    throw new Error(`No implementation found for ${params.selectedApi}`);
  }

  return results[0];
}

export const getAppInfo = async (
  facade: AgentsZapierFacade,
  { app }: { app: string },
): Promise<AppDetails> => {
  const implementation = await getImplementation(facade, { selectedApi: app });

  return {
    app_needs_auth: implementationNeedsAuth(implementation),
    implementation,
  };
};
